import React, { useEffect, useState, useRef } from 'react';
import { Box } from '@mui/material';
import { Container } from '@mui/system';
import XlsxDownloadButton from './JSONToXlsx';
import ReportFilter from './ReportFilter';
import PayrollReportTable from './PayrollReportTable';
import PaginationComponent from '../../../components/Pagination/Pagination';
import GenericLoader from '../../../components/Loader/GenericLoader';
import { useDispatch } from 'react-redux';
import DynamicTabsComponent from '../../../components/DynamicTabs/DynamicTabsComponent';
import {
  SHOW_NOTIFICATION,
  ReportComponentAttribute,
  RESET_COLUMN_FILTERS,
} from '../../../constants';
import moment from 'moment';
import NewPayrollReportTable from './NewPayrollReportTable';
import { useSelector } from 'react-redux';
import {
  getEncashedLeavesReport,
  getHolidaysUtilisationReport,
  getMonthlyPayrollReport,
} from '../../Services/ReportService';
import HolidayReportTable from './HolidayReportTable';
import LeavesTable from './LeavesTable';

const ReportComponent = (props) => {
  const columnFilters = useSelector(
    (state) => state.timingsReportColumnFilterState,
  );
  const [myLoader, setMyLoader] = React.useState(false);
  const [loadingApiCall, setLoadingApiCall] = React.useState(false);
  const [reportData, setReportData] = React.useState([]);
  const [holidayReportData, setHolidayReportData] = React.useState([]);
  const [tableLoadedOnce, setTableLoadedOnce] = React.useState(false);
  const dispatch = useDispatch();
  const [showError, setShowError] = useState(false);
  const [refresh, setRefresh] = useState(false);

  // employees type based on employee active tab status
  const [activeTab, setActiveTab] = React.useState(0);

  const [pageSize, setPageSize] = useState(5);
  const [totalPage, setTotalPage] = React.useState();
  const [pageNo, setPageNo] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [sortModel, setSortModel] = useState([]);
  const [filterData, setFilterData] = React.useState({
    reportType: '',
    users: [],
    columnFilters: [],
  });
  const [reportType, setReportType] = useState([]);

  const HRAdminWorkReportTabs = [
    {
      title: 'Active',
      index: 0,
    },
    {
      title: 'Offboarded',
      index: 1,
    }
  ]


  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const updateSortModal = (newValue) => {
    setSortModel(newValue);
  };

  const handleReportSubmit = async () => {
    setMyLoader(true);
    setLoadingApiCall(true);
    setTableLoadedOnce(true);

    const validColumnFilters = getValidColumnFilters();

    let newReportData;

    switch (filterData.reportType) {
      case 'Monthly Timings Report':
      case 'Monthly Timings Report (old)': {
        newReportData = await getMonthlyPayrollReport(
          filterData.startDate,
          filterData.endDate,
          filterData.users,
          validColumnFilters,
          pageNo,
          pageSize,
          activeTab,
        );
        break;
      }
      case 'Holiday Utilisation Report': {
        newReportData = await getHolidaysUtilisationReport({
          year: filterData.year,
          minUtilisedHoliday: filterData.minUtilisedHoliday,
          maxUtilisedHoliday: filterData.maxUtilisedHoliday,
          employeeIds: filterData.users,
          pageNumber: pageNo,
          pageSize: pageSize,
          // activeTab,
        });
        break;
      }
      case 'Leaves Encashment Report': {
        newReportData = await getEncashedLeavesReport({
          year: filterData.year,
          employeeIds: filterData.users,
          pageNumber: pageNo,
          pageSize: pageSize,
          // activeTab,
        });
        break;
      }
      default:
        break;
    }

    if (newReportData?.isError === false) {
      setReportData(newReportData?.data);
      setMyLoader(false);
      setLoadingApiCall(false);
      setTotalPage(newReportData.data.data.totalPages || 1);
    } else {
      setMyLoader(false);
      setLoadingApiCall(false);
      if (newReportData) {
        dipatchNotification(newReportData.type, newReportData.message);
      }
    }
    setShowError(false);
  };

  // const handleFilterSubmit = async (validColumnFilterArray) => {
  //   let newReportData;
  //   newReportData = await getMonthlyPayrollReport(
  //     filterData.startDate,
  //     filterData.endDate,
  //     filterData.users,
  //     validColumnFilterArray,
  //     pageNo,
  //     pageSize,
  //   );
  //   if (newReportData.isError === false) {
  //     setReportData(newReportData.data);
  //     setTotalPage(newReportData?.data?.data?.totalPages || 1);
  //   }
  //   setShowError(false);
  //   if (reportData && reportData.length > 0 && reportData.status !== 200) {
  //     console.log(reportData);
  //     dipatchNotification(reportData.type, reportData.message);
  //   }
  // };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefresh(!refresh);
  };

  // removes the null-void column filter values
  const getValidColumnFilters = () => {
    const columnFilterArray = Object.values(columnFilters);
    const validColumnFilterArray = columnFilterArray.filter((filter) => {
      return (
        filter.argument !== '' &&
        filter.value !== '' &&
        filter.value !== NaN &&
        filter.value !== null
      );
    });
    validColumnFilterArray.shift();
    setFilterData({
      ...filterData,
      columnFilters: validColumnFilterArray,
    });
    return validColumnFilterArray;
  };

  // pagination changes
  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    setPageNo(0);
    setPage(1);
    setRefresh(!refresh);
  };

  // load report component content
  function renderReportComponentContent(
    reportType,
    reportTab,
    reportData,
    filterData,
    myLoader,
    pageNo,
    pageSize,
  ) {

    switch (reportType) {
      case 'Monthly Timings Report':
        return (
          <NewPayrollReportTable
            reportData={reportData}
            filterData={filterData}
            setFilterData={setFilterData}
            myLoader={myLoader}
            pageNo={pageNo}
            pageSize={pageSize}
          />
        );

      case 'Monthly Timings Report (old)':
        return (
          <PayrollReportTable
            reportData={reportData}
            pageNo={pageNo}
            pageSize={pageSize}
            sortModel={sortModel}
            setSortModel={setSortModel}
          />
        );

      case 'Holiday Utilisation Report':
        return (
          <HolidayReportTable
            reportData={reportData}
            page={page}
            pageSize={pageSize}
          />
        );

      case 'Leaves Encashment Report':
        return (
          <LeavesTable
            reportData={reportData}
            page={page}
            pageSize={pageSize}
          />
        );

      default:
        return null;
    }
  }

  const getYearsList = () => {
    const yearsList = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= currentYear - 30; i--) {
      yearsList.push(i);
    }
    return yearsList;
  };

  useEffect(() => {
    setReportType([
      {
        label: 'Monthly Timings Report',
        id: '1',
        config: {
          monthlyPicker: true,
        },
      },
      {
        label: 'Monthly Timings Report (old)',
        id: '3',
        config: {
          monthlyPicker: true,
        },
      },
    ]);

    // call this function only if reportType is not a blank entry
    if (filterData.reportType !== '') {
      handleReportSubmit();
    }
    // {
    //   label: 'Leaves Encashment Report',
    //   id: '4',
    //   config: {
    //     yearSelector: true,
    //     selectField: [
    //       {
    //         label: 'Select Year',
    //         name: 'year',
    //         options: getYearsList(),
    //       },
    //     ],
    //   },
    // },
    // {
    //   label: 'Holiday Utilisation Report',
    //   id: '2',
    //   config: {
    //     yearSelector: true,
    //     selectField: [
    //       {
    //         label: 'Select Year',
    //         name: 'year',
    //         options: getYearsList(),
    //       },
    //     ],
    //     textField: [
    //       {
    //         label: 'Minimum Used Holiday',
    //         name: 'minUtilisedHoliday',
    //         type: 'number',
    //       },
    //       {
    //         label: 'Maximum Used Holdiay',
    //         name: 'maxUtilisedHoliday',
    //         type: 'number',
    //       },
    //     ],
    //     minMaxSelector: true,
    //   },
    // },
  }, [refresh, activeTab]);

  return (
    <Container maxWidth={false} sx={{ ml: '-30px' }}>
      <Box className="main-content-overlay">
        <Box className="main-content-div">
          <ReportFilter
            myLoader={loadingApiCall}
            setMyLoader={setMyLoader}
            filterData={filterData}
            setFilterData={setFilterData}
            reportType={reportType}
            refresh={refresh}
            setRefresh={setRefresh}
          />
          {tableLoadedOnce ? (
            <>
              {myLoader ? (
                <div>
                  <GenericLoader
                    rectAttributes={ReportComponentAttribute}
                    showError={showError}
                    setShowError={setShowError}
                  />
                </div>
              ) : (
                <>
                  <>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        mr: '-16px',
                      }}
                    >

                      {(() => {
                        switch (filterData.reportType) {
                          case 'Monthly Timings Report':
                          case 'Monthly Timings Report (old)':
                            return (
                              // download section needs to be fixed with 
                              // updated records as per filter type
                              <XlsxDownloadButton
                                startDate={moment(
                                  new Date(filterData.startDate),
                                ).format('YYYY-MM-DD')}
                                endDate={moment(
                                  new Date(filterData.endDate),
                                ).format('YYYY-MM-DD')}
                                userList={filterData.users}
                                empStatus={activeTab === 0 ? "Active" : "Off-boarded"}
                                activeTab={activeTab}
                                filterData={filterData}
                                sortModel={sortModel}
                              />

                            );

                          default:
                            return (
                              <Box
                                sx={{
                                  height: '50px',
                                }}
                              ></Box>
                            );
                        }
                      })()}
                    </Box>

                    {filterData && Object.keys(filterData).length !== 0 && (
                      <>
                        {/* tab component for HR/Admin work report */}
                        <div>
                          <DynamicTabsComponent
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            TabsList={HRAdminWorkReportTabs}
                          />
                        </div>

                        {renderReportComponentContent(
                          filterData.reportType,
                          activeTab,
                          reportData,
                          filterData,
                          myLoader,
                          pageNo,
                          pageSize,
                        )}
                        <Box
                          className="page-holder"
                          sx={{ marginTop: '12px', marginBottom: '9px' }}
                        >
                          <PaginationComponent
                            count={totalPage}
                            page={page}
                            pageChange={pageChange}
                            pageSize={pageSize}
                            handlePageSizeChange={handlePageSizeChange}
                            paginationTitle="People per page"
                          />
                        </Box>
                      </>
                    )}
                  </>
                </>
              )}
            </>
          ) : (
            ''
          )}
        </Box>
      </Box>
    </Container>
  );
};
export default ReportComponent;
